import { actionTypes, mutationTypes, getterTypes } from './types';
import _service from '../api';

const actions = {
  async [actionTypes.FETCH_CATEGORIES]({ commit, getters }) {
    if (getters[getterTypes.GET_CATEGORIES].length == 0) {
      const { data } = await _service.getCategories();
      if (data) {
        commit(
          mutationTypes.SET_CATEGORIES,
          data.sort((a, b) => a.name.localeCompare(b.name))
        );
      }
    }
  },
  async [actionTypes.FETCH_RESULTS]({ commit }, filters) {
    const { data } = await _service.getForms(filters);
    if (data) {
      commit(mutationTypes.SET_RESULTS, data);
    }
  },
};

export default actions;
